import { ITranslationList } from ".";

export const list: ITranslationList = new Map([
  ["Premium", "Premium"],
  ["What are you looking for?", "¿Qué estás buscando?"],
  ["Home page", "Página de inicio"],
  ["Menu", "Menú"],
  ["Search", "Buscar"],
  ["User menu", "Menú del usuario"],
  ["Back", "Volver"],
  ["Clear search", "Borrar la búsqueda"],
  ["Cancel", "Cancelar"],
  ["Popular", "Popular"],
  ["History", "Historia"],
  ["Suggestions", "Sugerencias"],
  ["Shopping List", "Lista de compras"],
  ["Close Menu", "Cerrar Menú"],
  ["Only available in Premium Subscriptions", "Only available in Premium Subscriptions"],
  ["Header", "Header"],
  ["You have items in the Shopping List", "You have items in the Shopping List"],
  ["DD Pro", "DD Pro"],
  ["Access admin dashboard", "Access admin dashboard"],
  ["Challenges", "Challenges"],
  ["Trending", "Trending"],
  ["My tracking", "My tracking"],
]);
